import React, { FC } from 'react'
import { MenuItem, Select, Menu as MuiMenu, Divider } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { theme, Space } from '../../ui'
import styled from 'styled-components'
import { Menu, ExitToApp } from '@material-ui/icons'
import useStore from 'store'
import kehilaMigrationWizardStore from 'store/kehilaMigrationWizard.store'

const Container = styled.div`
  display:flex;
  justify-content:center;
  align-items:center;
  margin-top:5px;
  cursor:pointer;
`
const SuperUserMenu: FC = () => {
    const { t, i18n } = useTranslation('superUserMenu')
    const { orgs, modulesStore, csvStore, user: userStore, members: membersStore } = useStore()
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
    const openActionMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }
    const createCommunity = () => {
        handleClose()
        orgs.openNewCommunityModal()
    }
    const createModule = () => {
        handleClose()
        modulesStore.openModuleModal()
    }

    const openCsv = () => {
        handleClose()
        csvStore.openCSV()
    }

    const openImportUsersToGroup = () => {
        handleClose()
        csvStore.openGroupImportModal()
    }

    const openCsvSocialNumberList = () => {
        handleClose()
        csvStore.handleCSVMapSocialIdwithCntactModal(true)
    }

    const openCommunitySettingsModal = () => {
        handleClose()
        orgs.setShowCommunitySettingsModal(true)
    }

    const openMapSettingsModal = () =>  {
        handleClose()
        orgs.setShowMapSettingsModal(true)
    }

    const openCouncilModal = () => {
        handleClose()
        orgs.setShowCouncilModalModal(true)
    }
    
    const openListUsersToRemoveModal = () => {
        handleClose()
        userStore.setShowUserListToRemoveModal(true)
    }

    // The label is the language being switched to, written in that language, so
    // it reads the same way round whichever one the interface is in.
    const isHebrew = i18n.language?.startsWith('he')

    const switchLanguage = () => {
        handleClose()
        i18n.changeLanguage(isHebrew ? 'en' : 'he')
    }

    const openKehilaMigrationWizard = () => {
        handleClose()
        kehilaMigrationWizardStore.open()
    }

    const logout = () => {
        handleClose()
        userStore.logout()
    }

    return (
        <>
            <Container
                onClick={openActionMenu}
            >
                <Menu
                    style={{ color: 'white' }}
                    color={'primary'}
                >
                </Menu>
            </Container>

            <MuiMenu
                id='super-user-menu'
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                onBackdropClick={handleClose}
            >
                <MenuItem
                    onClick={createCommunity}
                    value='he'>{t`createNewCommunity`}
                </MenuItem>
                <MenuItem
                    onClick={createModule}
                    value='en'>{t`createNewModule`}
                </MenuItem>
                <MenuItem
                    onClick={openCsv}
                    value='en'>{t`members:addMany`}
                </MenuItem>
                <MenuItem
                    onClick={openImportUsersToGroup}
                    value='en'>{t`members:addManyToGroup`}
                </MenuItem>
                <MenuItem
                    onClick={openCsvSocialNumberList}
                    value='en'>{t`mapSociaNumber`}
                </MenuItem>
                <MenuItem
                    onClick={openCommunitySettingsModal}
                    value='en'>
                    {t`communitySettings`}
                </MenuItem>
                <MenuItem
                    onClick={openMapSettingsModal}
                    value='en'>
                    {t`mapSettings`}
                </MenuItem>
                <MenuItem
                    onClick={openCouncilModal}
                    value='en'>
                    {t`councilSettings`}
                </MenuItem>
                <MenuItem
                    onClick={openKehilaMigrationWizard}
                    value='en'>
                    {t`migrateProtocolsFromKehila`}
                </MenuItem>

                <Divider />
                <MenuItem onClick={switchLanguage}>
                    {isHebrew ? 'English' : 'עברית'}
                </MenuItem>

                {membersStore.orgMembersSorted.length > 0 &&
                  <MenuItem
                      style={{ color: theme.color.red }}
                      onClick={openListUsersToRemoveModal}
                      value='en'>
                      {t`removeListOfUsers`}
                  </MenuItem>}

                <Divider />
                <MenuItem
                    style={{ color: theme.color.red }}
                    onClick={logout}>
                    <ExitToApp />
                    <Space width={0.5} />
                    {t`app:logout`}
                </MenuItem>
            </MuiMenu>
        </>
    )
}

export default SuperUserMenu
